/**
 * Product theme preference (DESIGN.md §9). Stored in the `wisprs_theme`
 * cookie so server renders can stamp `data-theme` on the product root and an
 * explicit choice never flashes. `system` leaves the attribute off; a tiny
 * inline script resolves it before first paint (see theme-script.tsx).
 */
export const THEME_COOKIE = 'wisprs_theme';

export const THEME_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export type ThemePreference = 'light' | 'dark' | 'system';

export type ResolvedTheme = 'light' | 'dark';

export function parseThemePreference(value: string | null | undefined): ThemePreference {
  return value === 'light' || value === 'dark' ? value : 'system';
}

/** Attribute value for SSR: only explicit choices are known on the server. */
export function themeAttrFor(preference: ThemePreference): ResolvedTheme | undefined {
  return preference === 'system' ? undefined : preference;
}
